
const baseurl = "https://encryption.edukrypt.app/lmsapi";
const apikey = "aa6bf24f1b12b0b96c9c6cd249c36d42";
const domain = "https://pathoelite.in";


// const baseurl = "http://localhost/saas_encryption/lmsapi";
// const apikey = "1a973f53cfa911ca8a4cc5e7b235ab4d";
// const domain = "https://sbaedu.com";


export {
    baseurl,
    apikey,
    domain
} ;